export const taxAssessmentsPtBr = {
  list: {
    title: 'Apurações fiscais',
    subtitle: 'Revisão e fechamento de tributos por contribuinte',
    statusTabs: 'Situação das apurações',
    emptyTitle: 'Nenhuma apuração encontrada',
    empty: 'Gere uma apuração para o período ou ajuste os filtros.',
    noTaxpayersTitle: 'Nenhum contribuinte fiscal disponível',
    noTaxpayers: 'Configure o contribuinte e suas entidades antes de gerar a apuração.',
    loading: 'Carregando apurações',
    range: '{{start}}–{{end}} de {{total}} apurações',
  },
  detail: {
    title: 'Apuração de PIS/COFINS',
    revision: 'revisão {{number}}',
    loading: 'Carregando apuração…',
    tabsLabel: 'Detalhes da apuração',
    objective: 'Objetivo',
    objectives: {
      calculation:
        'Validar o valor a recolher por tributo, conciliando o cálculo fiscal com as provisões, os ajustes, os créditos e as retenções.',
      members:
        'Conferir as entidades incluídas na apuração e os valores atribuídos à matriz e a cada filial.',
      evidence:
        'Conferir os documentos e fatos que sustentam o cálculo e rastrear a origem e a utilização de créditos e retenções.',
      journals:
        'Conferir os efeitos contábeis vinculados à apuração, verificando contas, débitos, créditos, valores e datas dos lançamentos.',
      close:
        'Verificar o requisito de aprovação fiscal das entidades desta apuração. Consulte o checklist para avaliar as demais pendências do fechamento contábil.',
    },
    tabs: {
      calculation: 'Cálculo',
      members: 'Entidades',
      evidence: 'Evidências',
      journals: 'Lançamentos',
      close: 'Fechamento',
    },
  },
  statusTabs: {
    ALL: 'Todas',
    DRAFT: 'Em revisão',
    OUTDATED: 'Desatualizadas',
    APPROVED: 'Aprovadas',
  },
  status: { DRAFT: 'Em revisão', OUTDATED: 'Desatualizada', APPROVED: 'Aprovada' },
  filters: {
    taxpayer: 'Contribuinte',
    entity: 'Filtrar entidade',
    allEntities: 'Todas as entidades',
    selectedEntity: 'Entidade selecionada',
    remove: 'Remover filtro: {{label}}',
    status: 'Filtrar situação',
    period: 'Período legal',
    correction: 'Aviso de retificação',
    allCorrections: 'Todos os avisos',
    correctionValues: { yes: 'Requer retificação', no: 'Sem retificação' },
    active: 'Filtros ativos',
    clear: 'Limpar',
  },
  table: {
    entity: 'Entidade',
    taxpayer: 'Contribuinte',
    assessmentTaxpayer: 'Apuração / contribuinte',
    period: 'Período legal',
    status: 'Situação',
    correction: 'Retificação',
    tax: 'Tributo',
    payableByTax: 'A recolher por tributo',
    needsCorrection: 'Requer retificação',
    revision: 'Revisão {{number}}',
  },
  kind: {
    PIS_COFINS_MONTHLY: 'PIS/COFINS mensal',
    IRPJ_CSLL_PRESUMED_MONTHLY: 'IRPJ/CSLL presumido · provisão mensal',
    IRPJ_CSLL_PRESUMED_QUARTERLY: 'IRPJ/CSLL presumido · trimestre',
    IRPJ_CSLL_ACTUAL_QUARTERLY: 'IRPJ/CSLL real · trimestre',
    IRPJ_CSLL_ACTUAL_ANNUAL_ESTIMATE: 'IRPJ/CSLL real · estimativa anual',
    other: 'Apuração fiscal',
  },
  actions: {
    generate: 'Nova apuração',
    refresh: 'Atualizar lista',
    open: 'Abrir',
    back: 'Voltar às apurações',
    retry: 'Tentar novamente',
    cancel: 'Cancelar',
    approve: 'Revisar e aprovar',
    confirmApprove: 'Confirmar aprovação',
    refreshSources: 'Atualizar fontes',
    rerun: 'Gerar nova revisão',
    releaseDeferred: 'Liberar tributo diferido',
    confirmRelease: 'Aprovar e contabilizar',
  },
  generate: {
    title: 'Gerar apuração',
    description: 'O regime vigente e as fontes do período definem o cálculo.',
    calculationType: 'Cálculo disponível:',
    errorTitle: 'Não foi possível gerar a apuração',
    openSetup: 'Abrir configuração fiscal da entidade',
  },
  yearlyElection: {
    title: 'Defina a escolha anual de créditos de {{year}}',
    description:
      'Registre a evidência que sustenta a apropriação de créditos de receitas mistas para este contribuinte.',
    methodLabel: 'Método disponível',
    methodRevenueProration: 'Rateio proporcional à receita (Método II)',
    evidenceCode: 'Referência da evidência',
    evidenceDescription: 'Descrição da evidência',
    characterCount: '{{count}} de {{max}} caracteres',
    confirmation:
      'Confirmo o rateio proporcional à receita para todo o ano-calendário {{year}} e entendo que a escolha não poderá ser alterada depois de registrada.',
    saved: 'Opção anual registrada. Você já pode gerar a apuração.',
    save: 'Salvar escolha anual',
    saving: 'Salvando escolha…',
  },
  approve: {
    title: 'Aprovar esta apuração?',
    description: 'A aprovação registra a revisão, as compensações e os lançamentos por tributo.',
    success: 'Apuração aprovada. Confira os efeitos contábeis na aba Lançamentos.',
  },
  accountingCorrection: {
    savedTitle: 'Decisão contábil registrada',
    title: 'Classificação contábil da correção',
    description:
      'A revisão altera o reconhecimento contábil, os valores registrados ou a base de custo de uma apuração já aprovada. Classifique o fato com base na evidência; o fechamento operacional do mês, sozinho, não define erro de período anterior.',
    classification: 'Natureza da correção',
    select: 'Selecione a natureza',
    evidenceCode: 'Referência da evidência',
    evidenceDescription: 'Descrição e conclusão da análise',
    classifiedBy: 'Classificada por',
    classifiedAt: 'Classificada em',
    unknownActor: 'Responsável não disponível',
    options: {
      CURRENT_PERIOD_NEW_LEGAL_FACT: 'Nova operação ou fato jurídico do período corrente',
      CURRENT_REPORTING_PERIOD_ERROR: 'Erro do período corrente ainda não autorizado',
      ESTIMATE_CHANGE_CURRENT_PERIOD: 'Mudança de estimativa por nova informação',
      PRIOR_AUTHORIZED_REPORTING_PERIOD_ERROR: 'Erro de período com demonstrações autorizadas',
    },
    priorAuthorizedUnsupported:
      'Este caso exige fluxo de reapresentação comparativa ou ajuste de saldos de abertura. A aprovação permanece bloqueada até esse fluxo existir.',
    currentPeriodReopenRequired:
      'Reabra cada período contábil original afetado antes de aprovar esta classificação do período corrente.',
    reopenNotice:
      'Reabrir o período apenas permite lançar no razão original; isso não conclui reapresentação, divulgação ou autorização das demonstrações.',
  },
  commonUseAccountingTreatment: {
    summaryTitle: 'Rateio dos créditos de ativos',
    summaryDescription:
      'Parcelas deste período: a parte excluída do crédito compõe o custo do ativo. O valor elegível pode ser utilizado na apuração ou permanecer como saldo.',
    potentialAmount: 'Parcela integral',
    eligibleAmount: 'Crédito elegível',
    excludedAmount: 'Parcela excluída',
    tax: 'Tributo',

    title: 'Tratamento contábil do crédito de uso comum',
    description:
      'Esta apuração ajusta o custo de um ativo pela parcela legalmente excluída do crédito de uso comum. Revise a natureza contábil com evidência própria; o sistema não presume mudança de estimativa.',
    treatment: 'Natureza do ajuste no custo',
    select: 'Selecione a natureza',
    evidenceCode: 'Referência da evidência contábil',
    evidenceDescription: 'Descrição e conclusão contábil',
    options: {
      CURRENT_PERIOD_NEW_LEGAL_FACT: 'Fato jurídico novo do período corrente',
      CURRENT_REPORTING_PERIOD_ERROR: 'Erro do período corrente ainda não autorizado',
    },
  },
  entitlementCorrection: {
    open: 'Revisar estorno vinculado',
    title: 'Estornar transição do crédito?',
    description:
      'Confira o estorno exato vinculado à transição. Contas, valor e dimensões são determinados pelo lançamento original.',
    amount: 'Valor do estorno',
    originalDate: 'Data do lançamento original',
    periodStatus: 'Período contábil original',
    status: { OPEN: 'Aberto', CLOSED: 'Fechado', LOCKED: 'Travado', MISSING: 'Não encontrado' },
    reopenRequired:
      'Reabra o período contábil original antes de confirmar. O estorno não pode ser lançado em outro período.',
    evidenceCode: 'Referência da evidência',
    evidenceDescription: 'Descrição e motivo da correção',
    loading: 'Carregando o estorno vinculado…',
    confirm: 'Confirmar estorno',
    success: 'Transição estornada. Atualize as fontes da apuração para continuar.',
    recoverySteps: 'Ordem dos estornos (efeito mais recente primeiro)',
    recoveryStep: 'Etapa {{number}}',
    recoveryNotice:
      'As etapas são executadas na ordem exibida para desfazer primeiro as reclassificações posteriores e preservar a origem do crédito.',
    stepScope: { entity: 'Entidade', book: 'Livro' },
    subledgerOnlyStep: 'Reversão automática do vínculo, sem novo lançamento contábil.',
    errors: {
      TAX_ENTITLEMENT_CORRECTION_SOURCE_CHANGED_RETRY:
        'A transição mudou. Feche esta janela, atualize a apuração e revise o estorno novamente.',
      TAX_ENTITLEMENT_CORRECTION_ORIGINAL_PERIOD_REOPEN_REQUIRED:
        'Reabra o período contábil original antes de confirmar este estorno.',
      TAX_ENTITLEMENT_CORRECTION_EVIDENCE_REQUIRED:
        'Informe a referência e a descrição da evidência da correção.',
      TAX_ENTITLEMENT_CORRECTION_SHARED_JOURNAL_UNSUPPORTED:
        'O lançamento original contém efeitos compartilhados que não podem ser estornados isoladamente por este fluxo.',
      TAX_ENTITLEMENT_TRANSITION_REVERSAL_BLOCKED:
        'Há consumo ou outra transição posterior. Resolva primeiro a consequência indicada na apuração.',
    },
  },
  entitlementSegregation: {
    open: 'Segregar saldo excedente',
    title: 'Segregar retenção excedente?',
    description:
      'O saldo não utilizado será movido para uma conta segregada por um lançamento vinculado à origem. Ele deixará de ser consumido automaticamente nas próximas apurações.',
    tax: 'Tributo',
    amount: 'Saldo a segregar',
    postingDate: 'Data do lançamento',
    periodStatus: 'Período contábil',
    reopenRequired:
      'Reabra o período contábil da apuração antes de confirmar. A segregação não pode ser lançada em outro período.',
    evidenceCode: 'Referência da evidência',
    evidenceDescription: 'Descrição e fundamento da segregação',
    loading: 'Carregando a prévia da segregação…',
    confirm: 'Confirmar segregação',
    success: 'Retenção excedente segregada e lançamento registrado.',
    errors: {
      TAX_ENTITLEMENT_SEGREGATION_NOT_AVAILABLE:
        'Este saldo não está mais disponível para segregação. Atualize a apuração.',
      TAX_ENTITLEMENT_SEGREGATION_SOURCE_JOURNAL_REQUIRED:
        'A retenção não possui um lançamento contábil de origem válido para a segregação.',
      TAX_ENTITLEMENT_SEGREGATION_SOURCE_CHANGED_RETRY:
        'O saldo mudou. Feche esta janela, atualize a apuração e revise a segregação novamente.',
      TAX_ENTITLEMENT_SEGREGATION_ORIGINAL_PERIOD_REOPEN_REQUIRED:
        'Reabra o período contábil da apuração antes de confirmar a segregação.',
      TAX_ENTITLEMENT_SEGREGATION_ACCOUNT_MAPPING_REQUIRED:
        'Mapeie as contas da retenção e do saldo segregado antes de continuar.',
      TAX_ENTITLEMENT_SEGREGATION_EVIDENCE_REQUIRED:
        'Informe a referência e a descrição da evidência da segregação.',
    },
  },
  refresh: {
    title: 'Atualizar as fontes?',
    description: 'O cálculo será refeito com as fontes atuais deste período.',
    success: 'Fontes atualizadas e apuração recalculada.',
  },
  rerun: {
    title: 'Gerar uma nova revisão?',
    description:
      'A revisão aprovada permanece no histórico e as fontes atuais formam uma nova revisão.',
    success: 'Nova revisão gerada com as fontes atuais.',
  },
  release: {
    title: 'Liberar todo o tributo diferido?',
    description:
      'Revise a prévia vinculada. A aprovação autoriza uma única contabilização desta liberação.',
    effectiveDate: 'Mudança de regime',
    postingDate: 'Data da contabilização',
    priorPeriod:
      'A liberação pertence à competência anterior à mudança e exige que esse período contábil esteja aberto.',
    incompletePreview:
      'A prévia não informa todas as datas e valores necessários. Feche esta confirmação e solicite uma nova prévia.',
    provisions: 'Provisões afetadas',
    total: 'Total a liberar',
    boundPreview: 'Prévia protegida pela versão {{version}}.',
    entity: 'Entidade',
    tax: 'Tributo / conta fiscal',
    period: 'Competência',
    amount: 'Valor a liberar',
    origin: 'Origem',
    statutoryBook: 'Livro estatutário',
    unknownEntity: 'Entidade fiscal',
    openEvidence: 'Abrir evidências',
    success: 'Tributo diferido liberado e contabilizado.',
  },
  calculation: {
    title: 'Reconciliação por tributo',
    purchaseCreditTimingTitle: 'Quando entram os créditos de compras',
    purchaseCreditTiming:
      'Neste cálculo, compras comuns elegíveis no regime não cumulativo entram pela competência da conta, após sua aprovação e provisionamento contábil, mesmo sem pagamento ao fornecedor. No imobilizado, a opção de crédito imediato confirmada na revisão do bem reconhece o crédito na aquisição e no provisionamento; o crédito por depreciação fiscal permanece a apropriar até a primeira utilização e depois segue as quotas fiscais. Na opção em 1/48, entram somente as parcelas da competência, a partir do início registrado; o saldo futuro continua a apropriar. Nenhuma dessas formas depende do pagamento ao fornecedor. O valor em “Crédito aplicado” é o utilizado nesta revisão para reduzir o tributo a recolher. Confira as contas de origem em Evidências → Fontes.',
    gross: 'Tributo bruto',
    provision: 'Provisão efetiva',
    trueUp: 'Ajuste de despesa',
    credit: 'Crédito aplicado',
    withholding: 'Retenção aplicada',
    payable: 'A recolher',
  },
  members: {
    title: 'Reconciliação por entidade',
    member: 'Entidade',
    transferEvidenceNote:
      'As transferências efetivamente contabilizadas entre filial e matriz são apresentadas na aba Lançamentos.',
    role: { HEAD_OFFICE: 'Matriz', BRANCH: 'Filial', other: 'Entidade' },
  },
  evidence: {
    title: 'Documentos e fatos da revisão',
    range: '{{start}}–{{end}} de {{total}} registros',
    tabsLabel: 'Categoria da evidência',
    emptyTitle: 'Nenhuma evidência encontrada',
    noApplicationsTitle: 'Nenhum crédito ou retenção aplicado nesta apuração',
    noApplicationsDescription:
      'Sem aplicação nesta revisão. Saldo disponível e valor aplicado são informações distintas; o valor de origem de uma fonte pode já ter sido consumido.',
    currentPurchaseBalancesTitle: 'Saldo disponível atual de créditos de compras',
    purchaseBalanceUnknownCatalog: 'Código fiscal não identificado',
    purchaseBalanceUncertain: 'Aplicabilidade nesta apuração não determinada.',
    currentPurchaseBalancesDescription:
      'Saldo atual dos créditos registrados até esta competência, separado dos valores aplicados nesta revisão e dos filtros da tabela. Rascunhos podem reservar parte do saldo e reduzir o valor disponível; somente a aprovação contabiliza o consumo. Correções posteriores também podem alterá-lo. Não representa pagamento nem garante aplicação automática em outro período.',
    noCurrentPurchaseBalance: 'Não há saldo disponível de créditos de compras nesse escopo.',
    empty: 'Não há registros nesta categoria para os filtros selecionados.',
    emptyFiltered:
      'Nenhum lançamento corresponde aos filtros selecionados. Ajuste ou limpe os filtros.',
    filters: {
      tax: 'Tributo',
      type: 'Tipo',
      status: 'Situação',
      date: 'Data',
      filter: 'Filtrar por {{label}}',
      all: 'Todos',
      dateRange: '{{from}} a {{to}}',
    },
    tabs: {
      sources: 'Fontes',
      entitlements: 'Créditos e retenções',
      origins: 'Origens',
      consumptions: 'Consumos',
      postings: 'Lançamentos',
    },
    source: 'Documento / fato fiscal',
    date: 'Data',
    amount: 'Valor de origem',
    journal: 'Diário',
    actions: 'Ações',
    viewOrigin: 'Ver origem',
    viewFiscalProvision: 'Ver provisão fiscal',
    entitlement: 'Crédito / retenção',
    origin: 'Origem',
    consumption: 'Consumo da origem',
    status: 'Situação',
    recognized: 'Reconhecido',
    eligible: 'Elegível',
    available: 'Saldo disponível',
    availableNow: 'Disponível',
    availableBefore: 'Disponível antes',
    allocated: 'Alocado',
    applied: 'Aplicado atualmente',
    linkedGuides: '{{count}} vínculo(s) com guia',
    linkedDocument: 'Documento fiscal vinculado',
    sourceJournal: 'Lançamento contábil de origem',
    sourceRecorded: 'Fonte fiscal registrada',
  },
  journals: {
    title: 'Efeitos contábeis',
    emptyTitle: 'Nenhum lançamento da apuração',
    approvedWithoutAdditionalTitle: 'Apuração aprovada sem lançamento adicional',
    approvedWithoutAdditional:
      'A apuração fiscal foi aprovada, mas não houve ajustes, créditos ou retenções a contabilizar. As provisões já registradas nos documentos de origem foram preservadas e não foram duplicadas. A aprovação fiscal não fecha o período contábil; acompanhe esse status na aba Fechamento.',
    reviewEvidence: 'Revisar evidências',
    emptyDraft:
      'Os efeitos contábeis desta apuração serão gerados na aprovação, quando houver valores a contabilizar. Os lançamentos dos documentos de origem estão em Evidências.',
    emptyRecorded:
      'Não há efeitos contábeis registrados nesta revisão. Consulte os lançamentos dos documentos de origem em Evidências.',
    kind: 'Efeito',
    date: 'Data do lançamento',
    amount: 'Valor assinado',
    open: 'Ver lançamentos',
    subtitle: 'Diário {{id}}',
  },
  close: {
    title: 'Conexão com o fechamento',
    period: 'Competência fiscal',
    requirement: 'Requisito fiscal',
    approved: 'Apuração aprovada',
    pending: 'Aprovação pendente',
    openChecklist: 'Abrir checklist de fechamento',
    openEntityChecklist: 'Abrir checklist de fechamento de {{entity}}',
    periodUnavailable: 'Período contábil não identificado. Revise os períodos deste livro.',
  },
  warnings: {
    review: 'Revise a evidência antes de aprovar.',
    unknown: 'Há um aviso fiscal que precisa ser revisado.',
    PIS_COFINS_NEGATIVE_MONTH_NO_CARRY:
      'Há base tributária negativa nesta apuração. O valor a recolher do tributo e código de arrecadação afetados foi limitado a zero. Esse resíduo não gera crédito fiscal nem compensação automática.',
    legalMonth: 'Competência fiscal: {{month}}.',
    acknowledge: 'Revisei e estou ciente',
    acknowledged: 'Revisado',
    PIS_COFINS_PENDING_PROVISION: 'Há provisões de PIS ou COFINS pendentes nesta apuração.',
    PIS_COFINS_PENDING_CASH_RELEASE:
      'Há realizações ou estornos de PIS ou COFINS pendentes no regime de caixa.',
    TAX_ENTITLEMENT_MOVED_OUT_EXCEEDS_CORRECTED_AMOUNT:
      'O crédito recuperável corrigido já foi consumido ou reclassificado além do valor disponível. Estorne o consumo ou a reclassificação vinculada e tente novamente.',
    diagnostics: {
      context: '{{entity}} · competência {{month}}',
      unavailable:
        'Os detalhes desta pendência não estão completos. Atualize as fontes; se a pendência continuar, revise os tributos sobre a receita da entidade.',
      unavailableEntity: 'Entidade não identificada nesta revisão',
      unavailableMonth: 'não identificada',
      unavailableAmount: 'valor não informado',
      tax: '{{tax}} · {{amount}}',
      movementBaseAmount: 'Base da movimentação: {{amount}}',
      sourceProvisionAmount: 'Provisão de origem (total): {{amount}}',
      provisionCount_one: 'Provisão pendente: {{count}}',
      provisionCount_other: 'Provisões pendentes: {{count}}',
      accountCount_one: 'Conta contábil envolvida: {{count}}',
      accountCount_other: 'Contas contábeis envolvidas: {{count}}',
      movementDate: 'Data do movimento: {{date}}',
      journalCount: 'Lançamentos envolvidos: {{count}}',
      viewJournal: 'Ver lançamento de origem {{number}}',
      viewReversal: 'Ver estorno',
      viewGuide: 'Ver guia {{number}}',
      reviewSetup: 'Revisar tributos da entidade',
      source: {
        BLOCKED_MONTH: 'A correção dos tributos deste mês está bloqueada.',
        OWED_PROVISION: 'A provisão calculada ainda não foi contabilizada.',
        PENDING_GROUP: 'Há receitas cuja provisão depende de revisar a configuração fiscal.',
        FAILED_JOURNAL: 'A correção dos tributos do lançamento não foi concluída.',
        PENDING_RELEASE:
          'A realização ou o estorno no regime de caixa ainda não foi contabilizado.',
        RELEASE_FAILURE: 'A correção das realizações do regime de caixa não foi concluída.',
      },
    },
    PIS_COFINS_MIXED_REGIME_REVENUE_SPLIT_REQUIRED:
      'Há receitas cumulativas em uma apuração não cumulativa.',
    PURCHASE_CREDIT_SOURCE_FACT_CHANGED:
      'O documento de origem ou seu vínculo com o crédito de compra mudou desde a aprovação anterior. Revise a origem e os valores desta revisão antes de aprovar.',
    pendingProvisionAction: {
      HEAL: 'Execute novamente a correção dos tributos sobre a receita para {{month}} e recalcule a apuração.',
      REOPEN_AND_HEAL:
        '{{month}} está fechado. Reabra o período, execute novamente a correção dos tributos sobre a receita e recalcule a apuração.',
    },
    mixedRegimeAmount: '{{tax}} cumulativo: {{amount}} · código de arrecadação {{catalogCode}}.',
    mixedRegimeRecovery:
      'Esta revisão foi calculada antes da separação das receitas cumulativas e não cumulativas por código de arrecadação. Selecione Atualizar fontes, revise a nova revisão e então aprove.',
    catalogCodeUnavailable: 'não informado',
    PIS_COFINS_DECLARATION_CORRECTION_REQUIRED:
      'Fontes do período exigem retificação da declaração.',
    PIS_COFINS_CASH_BASIS_REVENUE_OUTSIDE_AR:
      'Há receita em regime de caixa fora do contas a receber.',
    DECLARATION_CORRECTION_REQUIRED_OD7: 'Um crédito recuperável alterou a apuração original.',
    LATE_REVENUE_DECLARATION_CORRECTION_I17:
      'Receita identificada depois da competência exige retificação.',
  },
  sourceType: {
    REVENUE_PROVISION: 'Provisão de receita',
    REVENUE_RELEASE: 'Realização de receita',
    PURCHASE_CREDIT: 'Crédito de compra',
    CUSTOMER_WITHHOLDING: 'Retenção do cliente',
    ADVANCE_ESTIMATE: 'Antecipação',
    FISCAL_HISTORY: 'Histórico fiscal',
    JOURNAL_LINE: 'Linha contábil',
    MANUAL_EVIDENCE: 'Evidência fiscal',
    other: 'Fonte fiscal',
  },
  entitlementType: {
    PURCHASE_CREDIT: 'Crédito de compra',
    CUSTOMER_WITHHOLDING: 'Retenção do cliente',
    SEGREGATED_RECOVERABLE: 'Recuperável segregado',
    LEGACY_CREDIT: 'Crédito legado',
    ADVANCE_ESTIMATE: 'Antecipação',
    ISS_PAID_RECOVERABLE: 'ISS recuperável',
    PAID_TAX_RECOVERABLE: 'Tributo pago recuperável',
    other: 'Crédito ou retenção fiscal',
  },
  allocationReason: {
    PURCHASE_CREDIT_OFFSET: 'Compensação de crédito de compra',
    WITHHOLDING_OFFSET: 'Compensação de retenção',
    ADVANCE_ESTIMATE_OFFSET: 'Compensação de antecipação',
    NEGATIVE_ASSESSMENT_DELTA: 'Ajuste negativo da apuração',
    HEAD_OFFICE_TRANSFER: 'Transferência à matriz',
    REVERSAL_CORRECTION: 'Correção de estorno',
    CORRECTION: 'Correção',
    REVERSAL: 'Estorno',
    ALLOCATE: 'Alocação',
    RELEASE: 'Liberação',
    RECLASSIFY_SEGREGATED: 'Reclassificação segregada',
    CONVERT_LEGACY: 'Conversão de crédito legado',
    other: 'Movimento fiscal',
  },
  originStatus: { ACTIVE: 'Disponível', REVERSED: 'Estornada' },
  originSourceType: {
    HEAD_OFFICE_TRANSFER: 'Transferência à matriz',
    AP_BILL_WITHHOLDING: 'Retenção de conta a pagar',
    AP_VENDOR_PAYMENT: 'Pagamento a fornecedor',
    AP_BILL_APPROVAL_LEGACY: 'Aprovação de conta a pagar anterior',
    TAX_LIABILITY_RAIL_MIGRATION: 'Saldo fiscal migrado',
    AR_DEBIT_NOTE: 'Nota de débito',
    CONTRACT_REVENUE_RECOGNITION: 'Reconhecimento de receita de contrato',
    GL_JOURNAL: 'Lançamento contábil',
    TAX_ASSESSMENT_TRUE_UP: 'Ajuste da apuração',

    other: 'Origem fiscal',
  },
  postingKind: {
    EXPENSE_TRUE_UP: 'Ajuste de despesa',
    SETTLEMENT_OFFSET: 'Compensação patrimonial',
    HEAD_OFFICE_TRANSFER: 'Transferência à matriz',
    HEAD_OFFICE_RECOVERABLE_TRANSFER: 'Transferência de crédito entre entidades',
    FIXED_ASSET_CREDIT_MATURATION: 'Apropriação de crédito do imobilizado',
    FIXED_ASSET_COMMON_USE_EXCLUSION: 'Exclusão de crédito de uso comum do imobilizado',
    GUIDE_REGISTRATION: 'Registro de guia',
    REVERSAL: 'Estorno',
    CORRECTION: 'Correção',
    other: 'Lançamento da apuração',
  },
  errors: {
    loadTitle: 'Não foi possível carregar as apurações',
    load: 'Tente novamente.',
    action: 'Não foi possível concluir a ação.',
    branchTransferAccountMissing:
      'Configure o mapeamento “{{slot}}” para a entidade “{{entity}}” antes de aprovar a transferência entre matriz e filial.',
    branchTransferAccountNotDedicated:
      'A conta “{{account}}”, mapeada em “{{slot}}” para a entidade “{{entity}}”, não está classificada para eliminação na consolidação. Crie uma conta dedicada com essa classificação e atualize o mapeamento antes de aprovar.',
    branchTransferSlots: {
      BRANCH_DUE_TO_HEAD_OFFICE: 'Conta a pagar à matriz',
      HEAD_OFFICE_DUE_FROM_BRANCH: 'Conta a receber da filial',
      BRANCH_DUE_FROM_HEAD_OFFICE: 'Conta a receber da matriz por créditos fiscais',
      HEAD_OFFICE_DUE_TO_BRANCH: 'Conta a pagar à filial por créditos fiscais',
    },
  },
};

export const taxAssessmentsEn = {
  list: {
    title: 'Tax assessments',
    subtitle: 'Tax review and close by taxpayer',
    statusTabs: 'Assessment status',
    emptyTitle: 'No assessments found',
    empty: 'Generate an assessment for the period or adjust the filters.',
    noTaxpayersTitle: 'No taxpayer is available',
    noTaxpayers: 'Configure the taxpayer and its entities before generating an assessment.',
    loading: 'Loading assessments',
    range: '{{start}}–{{end}} of {{total}} assessments',
  },
  detail: {
    title: 'PIS/COFINS assessment',
    revision: 'revision {{number}}',
    loading: 'Loading assessment…',
    tabsLabel: 'Assessment details',
    objective: 'Objective',
    objectives: {
      calculation:
        'Validate the amount payable for each tax by reconciling the tax calculation with provisions, adjustments, credits and withholdings.',
      members:
        'Check the entities included in the assessment and the amounts allocated to the head office and each branch.',
      evidence:
        'Check the documents and facts supporting the calculation and trace the origin and use of credits and withholdings.',
      journals:
        'Check the accounting effects linked to the assessment by reviewing posting accounts, debits, credits, amounts and dates.',
      close:
        'Check the tax approval requirement for entities in this assessment. Open the checklist to review the remaining accounting close requirements.',
    },
    tabs: {
      calculation: 'Calculation',
      members: 'Entities',
      evidence: 'Evidence',
      journals: 'Postings',
      close: 'Close',
    },
  },
  statusTabs: { ALL: 'All', DRAFT: 'In review', OUTDATED: 'Outdated', APPROVED: 'Approved' },
  status: { DRAFT: 'In review', OUTDATED: 'Outdated', APPROVED: 'Approved' },
  filters: {
    taxpayer: 'Taxpayer',
    entity: 'Filter entity',
    allEntities: 'All entities',
    selectedEntity: 'Selected entity',
    remove: 'Remove filter: {{label}}',
    status: 'Filter status',
    period: 'Legal period',
    correction: 'Correction warning',
    allCorrections: 'All warnings',
    correctionValues: { yes: 'Correction required', no: 'No correction' },
    active: 'Active filters',
    clear: 'Clear',
  },
  table: {
    entity: 'Entity',
    taxpayer: 'Taxpayer',
    assessmentTaxpayer: 'Assessment / taxpayer',
    period: 'Legal period',
    status: 'Status',
    correction: 'Correction',
    tax: 'Tax',
    payableByTax: 'Payable by tax',
    needsCorrection: 'Correction required',
    revision: 'Revision {{number}}',
  },
  kind: {
    PIS_COFINS_MONTHLY: 'Monthly PIS/COFINS',
    IRPJ_CSLL_PRESUMED_MONTHLY: 'Presumed-profit IRPJ/CSLL · monthly provision',
    IRPJ_CSLL_PRESUMED_QUARTERLY: 'Presumed-profit IRPJ/CSLL · quarter',
    IRPJ_CSLL_ACTUAL_QUARTERLY: 'Actual-profit IRPJ/CSLL · quarter',
    IRPJ_CSLL_ACTUAL_ANNUAL_ESTIMATE: 'Actual-profit IRPJ/CSLL · annual estimate',
    other: 'Tax assessment',
  },
  actions: {
    generate: 'New assessment',
    refresh: 'Refresh list',
    open: 'Open',
    back: 'Back to assessments',
    retry: 'Try again',
    cancel: 'Cancel',
    approve: 'Review and approve',
    confirmApprove: 'Confirm approval',
    refreshSources: 'Refresh sources',
    rerun: 'Create new revision',
    releaseDeferred: 'Release deferred tax',
    confirmRelease: 'Approve and post',
  },
  generate: {
    title: 'Generate assessment',
    description: 'The effective regime and period sources determine the calculation.',
    calculationType: 'Available calculation:',
    errorTitle: 'Could not generate the assessment',
    openSetup: 'Open entity tax setup',
  },
  yearlyElection: {
    title: 'Set the {{year}} annual credit election',
    description:
      'Record the evidence that supports mixed-revenue credit appropriation for this taxpayer.',
    methodLabel: 'Available method',
    methodRevenueProration: 'Revenue proration (Method II)',
    evidenceCode: 'Evidence reference',
    evidenceDescription: 'Evidence description',
    characterCount: '{{count}} of {{max}} characters',
    confirmation:
      'I confirm revenue proration for the full {{year}} calendar year and understand this election cannot be changed after it is recorded.',
    saved: 'Annual choice recorded. You can now generate the assessment.',
    save: 'Save annual election',
    saving: 'Saving election…',
  },
  approve: {
    title: 'Approve this assessment?',
    description: 'Approval records the revision, offsets, and postings for each tax.',
    success: 'Assessment approved. Review the accounting effects on the Postings tab.',
  },
  accountingCorrection: {
    savedTitle: 'Recorded accounting decision',
    title: 'Accounting correction classification',
    description:
      'This revision changes accounting recognition, recorded amounts, or the cost basis of an approved assessment. Classify the fact from its evidence; an operationally closed month alone does not establish a prior-period error.',
    classification: 'Correction nature',
    select: 'Select the nature',
    evidenceCode: 'Evidence reference',
    evidenceDescription: 'Analysis and conclusion',
    classifiedBy: 'Classified by',
    classifiedAt: 'Classified on',
    unknownActor: 'Reviewer unavailable',
    options: {
      CURRENT_PERIOD_NEW_LEGAL_FACT: 'New operation or legal fact in the current period',
      CURRENT_REPORTING_PERIOD_ERROR: 'Current reporting-period error, statements not authorized',
      ESTIMATE_CHANGE_CURRENT_PERIOD: 'Estimate change from new information',
      PRIOR_AUTHORIZED_REPORTING_PERIOD_ERROR: 'Prior-period error in authorized statements',
    },
    priorAuthorizedUnsupported:
      'This case requires a comparative restatement or opening-balance workflow. Approval remains blocked until that workflow exists.',
    currentPeriodReopenRequired:
      'Reopen every affected original accounting period before approving this current-period classification.',
    reopenNotice:
      'Reopening a period only makes the original ledger editable; it does not complete restatement, disclosure, or financial-statement authorization.',
  },
  commonUseAccountingTreatment: {
    summaryTitle: 'Asset credit proration',
    summaryDescription:
      'Current-period installments: the excluded credit portion forms part of asset cost. The eligible amount may offset the assessment or remain available.',
    potentialAmount: 'Full installment',
    eligibleAmount: 'Eligible credit',
    excludedAmount: 'Excluded portion',
    tax: 'Tax',

    title: 'Common-use credit accounting treatment',
    description:
      'This assessment adjusts an asset cost for the legally excluded portion of a common-use credit. Review the accounting nature against its own evidence; the system does not presume an estimate change.',
    treatment: 'Cost adjustment nature',
    select: 'Select the nature',
    evidenceCode: 'Accounting evidence reference',
    evidenceDescription: 'Accounting analysis and conclusion',
    options: {
      CURRENT_PERIOD_NEW_LEGAL_FACT: 'New legal fact in the current period',
      CURRENT_REPORTING_PERIOD_ERROR: 'Current reporting-period error, statements not authorized',
    },
  },
  entitlementCorrection: {
    open: 'Review linked reversal',
    title: 'Reverse the credit transition?',
    description:
      'Review the exact reversal linked to the transition. Accounts, amount, and dimensions come from the original posting.',
    amount: 'Reversal amount',
    originalDate: 'Original posting date',
    periodStatus: 'Original accounting period',
    status: { OPEN: 'Open', CLOSED: 'Closed', LOCKED: 'Locked', MISSING: 'Not found' },
    reopenRequired:
      'Reopen the original accounting period before confirming. The reversal cannot be posted in another period.',
    evidenceCode: 'Evidence reference',
    evidenceDescription: 'Correction description and rationale',
    loading: 'Loading the linked reversal…',
    confirm: 'Confirm reversal',
    success: 'Transition reversed. Refresh the assessment sources to continue.',
    recoverySteps: 'Reversal order (most recent effect first)',
    recoveryStep: 'Step {{number}}',
    recoveryNotice:
      'The steps run in the displayed order so later reclassifications are undone first while preserving the credit origin.',
    stepScope: { entity: 'Entity', book: 'Book' },
    subledgerOnlyStep: 'Automatic subledger-link reversal, with no new journal entry.',
    errors: {
      TAX_ENTITLEMENT_CORRECTION_SOURCE_CHANGED_RETRY:
        'The transition changed. Close this dialog, refresh the assessment, and review the reversal again.',
      TAX_ENTITLEMENT_CORRECTION_ORIGINAL_PERIOD_REOPEN_REQUIRED:
        'Reopen the original accounting period before confirming this reversal.',
      TAX_ENTITLEMENT_CORRECTION_EVIDENCE_REQUIRED:
        'Enter the evidence reference and correction rationale.',
      TAX_ENTITLEMENT_CORRECTION_SHARED_JOURNAL_UNSUPPORTED:
        'The original journal has shared effects that this workflow cannot reverse in isolation.',
      TAX_ENTITLEMENT_TRANSITION_REVERSAL_BLOCKED:
        'A later consumption or transition remains. Resolve the consequence shown in the assessment first.',
    },
  },
  entitlementSegregation: {
    open: 'Segregate excess balance',
    title: 'Segregate excess withholding?',
    description:
      'The unused balance will move to a segregated account through a posting linked to its source. Future assessments will no longer consume it automatically.',
    tax: 'Tax',
    amount: 'Balance to segregate',
    postingDate: 'Posting date',
    periodStatus: 'Accounting period',
    reopenRequired:
      'Reopen the assessment accounting period before confirming. The segregation cannot be posted in another period.',
    evidenceCode: 'Evidence reference',
    evidenceDescription: 'Segregation description and rationale',
    loading: 'Loading the segregation preview…',
    confirm: 'Confirm segregation',
    success: 'Excess withholding segregated and journal posted.',
    errors: {
      TAX_ENTITLEMENT_SEGREGATION_NOT_AVAILABLE:
        'This balance is no longer available for segregation. Refresh the assessment.',
      TAX_ENTITLEMENT_SEGREGATION_SOURCE_JOURNAL_REQUIRED:
        'The withholding has no valid source journal for segregation.',
      TAX_ENTITLEMENT_SEGREGATION_SOURCE_CHANGED_RETRY:
        'The balance changed. Close this dialog, refresh the assessment, and review segregation again.',
      TAX_ENTITLEMENT_SEGREGATION_ORIGINAL_PERIOD_REOPEN_REQUIRED:
        'Reopen the assessment accounting period before confirming segregation.',
      TAX_ENTITLEMENT_SEGREGATION_ACCOUNT_MAPPING_REQUIRED:
        'Map the withholding and segregated-balance accounts before continuing.',
      TAX_ENTITLEMENT_SEGREGATION_EVIDENCE_REQUIRED:
        'Enter the segregation evidence reference and rationale.',
    },
  },
  refresh: {
    title: 'Refresh sources?',
    description: 'The calculation will be rebuilt from the current period sources.',
    success: 'Sources refreshed and assessment recalculated.',
  },
  rerun: {
    title: 'Create a new revision?',
    description: 'The approved revision stays in history and current sources form a new revision.',
    success: 'A new revision was generated from the current sources.',
  },
  release: {
    title: 'Release all deferred tax?',
    description:
      'Review the bound preview. Approval authorizes exactly one posting of this release.',
    effectiveDate: 'Regime change',
    postingDate: 'Posting date',
    priorPeriod:
      'The release belongs to the period before the change and requires that accounting period to be open.',
    incompletePreview:
      'The preview is missing required dates or amounts. Close this confirmation and request a new preview.',
    provisions: 'Affected provisions',
    total: 'Total to release',
    boundPreview: 'Preview protected by version {{version}}.',
    entity: 'Entity',
    tax: 'Tax / tax account',
    period: 'Period',
    amount: 'Amount to release',
    origin: 'Origin',
    statutoryBook: 'Statutory book',
    unknownEntity: 'Tax entity',
    openEvidence: 'Open evidence',
    success: 'Deferred tax released and posted.',
  },
  calculation: {
    title: 'Reconciliation by tax',
    purchaseCreditTimingTitle: 'When purchase credits are included',
    purchaseCreditTiming:
      'In this calculation, ordinary eligible purchases under the non-cumulative regime are included in the bill’s accrual period after approval and accounting accrual, even before the supplier is paid. For fixed assets, the immediate-credit option confirmed during asset review recognizes the credit on acquisition and accrual; the fiscal-depreciation credit remains deferred until first use and then follows the statutory installments. Under the 1/48 option, only the installments due for the period enter the calculation, from the recorded start period; the future balance remains deferred. None of these methods depends on supplier payment. “Credit applied” is the amount used in this revision to reduce tax payable. Review the source bills under Evidence → Sources.',
    gross: 'Gross tax',
    provision: 'Effective provision',
    trueUp: 'Expense true-up',
    credit: 'Credit applied',
    withholding: 'Withholding applied',
    payable: 'Payable',
  },
  members: {
    title: 'Reconciliation by entity',
    member: 'Entity',
    transferEvidenceNote:
      'Transfers actually posted between branches and the head office are shown on the Journals tab.',
    role: { HEAD_OFFICE: 'Head office', BRANCH: 'Branch', other: 'Entity' },
  },
  evidence: {
    title: 'Review documents and facts',
    range: '{{start}}–{{end}} of {{total}} records',
    tabsLabel: 'Evidence category',
    emptyTitle: 'No evidence found',
    noApplicationsTitle: 'No credit or withholding applied in this assessment',
    noApplicationsDescription:
      'Nothing was applied in this revision. Available balance and applied amount are separate; a source’s original amount may already have been consumed.',
    currentPurchaseBalancesTitle: 'Current available purchase-credit balance',
    purchaseBalanceUnknownCatalog: 'Tax catalog not identified',
    purchaseBalanceUncertain: 'Applicability in this assessment has not been determined.',
    currentPurchaseBalancesDescription:
      'Current balance of credits recorded through this fiscal period, separate from this revision’s applied amounts and table filters. Drafts may reserve part of the balance and reduce the available amount; only approval posts the consumption. Later corrections may also change it. It is not a payment or a guarantee of automatic application in another period.',
    noCurrentPurchaseBalance: 'No purchase-credit balance is available in this scope.',
    empty: 'There are no records in this category matching the selected filters.',
    emptyFiltered: 'No postings match the selected filters. Adjust or clear the filters.',
    filters: {
      tax: 'Tax',
      type: 'Type',
      status: 'Status',
      date: 'Date',
      filter: 'Filter by {{label}}',
      all: 'All',
      dateRange: '{{from}} to {{to}}',
    },
    tabs: {
      sources: 'Sources',
      entitlements: 'Credits and withholdings',
      origins: 'Origins',
      consumptions: 'Consumptions',
      postings: 'Postings',
    },
    source: 'Document / tax fact',
    date: 'Date',
    amount: 'Source amount',
    journal: 'Journal',
    actions: 'Actions',
    viewOrigin: 'View source',
    viewFiscalProvision: 'View tax provision',
    entitlement: 'Credit / withholding',
    origin: 'Origin',
    consumption: 'Origin consumption',
    status: 'Status',
    recognized: 'Recognized',
    eligible: 'Eligible',
    available: 'Available balance',
    availableNow: 'Available',
    availableBefore: 'Available before',
    allocated: 'Allocated',
    applied: 'Currently applied',
    linkedGuides: '{{count}} guide link(s)',
    linkedDocument: 'Linked tax document',
    sourceJournal: 'Source accounting entry',
    sourceRecorded: 'Recorded tax source',
  },
  journals: {
    title: 'Accounting effects',
    emptyTitle: 'No assessment postings',
    approvedWithoutAdditionalTitle: 'Assessment approved with no additional posting',
    approvedWithoutAdditional:
      'The tax assessment was approved, but there were no adjustments, credits, or withholdings to post. Provisions already recorded by the source documents were preserved and were not duplicated. Tax approval does not close the accounting period; track that status under Close.',
    reviewEvidence: 'Review evidence',
    emptyDraft:
      'Accounting effects for this assessment will be generated on approval when there are amounts to post. Source document postings are available under Evidence.',
    emptyRecorded:
      'No accounting effects are recorded for this revision. Source document postings are available under Evidence.',
    kind: 'Effect',
    date: 'Posting date',
    amount: 'Signed amount',
    open: 'View postings',
    subtitle: 'Journal {{id}}',
  },
  close: {
    title: 'Accounting close connection',
    period: 'Tax period',
    requirement: 'Tax requirement',
    approved: 'Assessment approved',
    pending: 'Approval pending',
    openChecklist: 'Open closing checklist',
    openEntityChecklist: 'Open closing checklist for {{entity}}',
    periodUnavailable: 'Accounting period could not be identified. Review this book’s periods.',
  },
  warnings: {
    review: 'Review the evidence before approval.',
    unknown: 'A tax warning needs review.',
    PIS_COFINS_NEGATIVE_MONTH_NO_CARRY:
      'This assessment contains a negative tax base. Payable for the affected tax and collection code was floored at zero. This residual does not create a tax credit or automatic carry.',
    legalMonth: 'Tax period: {{month}}.',
    acknowledge: 'I reviewed and acknowledge this',
    acknowledged: 'Reviewed',
    PIS_COFINS_PENDING_PROVISION: 'This assessment has pending PIS or COFINS provisions.',
    PIS_COFINS_PENDING_CASH_RELEASE: 'Cash-basis PIS or COFINS releases or reversals are pending.',
    TAX_ENTITLEMENT_MOVED_OUT_EXCEEDS_CORRECTED_AMOUNT:
      'The corrected recoverable credit has already been consumed or reclassified beyond the available amount. Reverse the linked consumption or reclassification and try again.',
    diagnostics: {
      context: '{{entity}} · tax period {{month}}',
      unavailable:
        'The details of this pending item are incomplete. Update the sources; if it persists, review the entity’s revenue taxes.',
      unavailableEntity: 'Entity not identified in this revision',
      unavailableMonth: 'not identified',
      unavailableAmount: 'amount not provided',
      tax: '{{tax}} · {{amount}}',
      movementBaseAmount: 'Movement base: {{amount}}',
      sourceProvisionAmount: 'Source provision (total): {{amount}}',
      provisionCount_one: 'Pending provision: {{count}}',
      provisionCount_other: 'Pending provisions: {{count}}',
      accountCount_one: 'Affected account: {{count}}',
      accountCount_other: 'Affected accounts: {{count}}',
      movementDate: 'Movement date: {{date}}',
      journalCount: 'Affected journal entries: {{count}}',
      viewJournal: 'View source journal {{number}}',
      viewReversal: 'View reversal',
      viewGuide: 'View tax guide {{number}}',
      reviewSetup: 'Review entity revenue taxes',
      source: {
        BLOCKED_MONTH: 'Revenue tax correction for this month is blocked.',
        OWED_PROVISION: 'The calculated provision has not been posted yet.',
        PENDING_GROUP: 'Revenue provisions require fiscal configuration review.',
        FAILED_JOURNAL: 'Revenue tax correction for the journal was not completed.',
        PENDING_RELEASE: 'The cash-basis release or reversal has not been posted yet.',
        RELEASE_FAILURE: 'Cash-basis release correction was not completed.',
      },
    },
    PIS_COFINS_MIXED_REGIME_REVENUE_SPLIT_REQUIRED:
      'A non-cumulative assessment contains cumulative revenue.',
    PURCHASE_CREDIT_SOURCE_FACT_CHANGED:
      'The source document or its link to the purchase credit changed since the previous approval. Review the source and the amounts in this revision before approval.',
    pendingProvisionAction: {
      HEAL: 'Run the Revenue Tax correction again for {{month}}, then recalculate the assessment.',
      REOPEN_AND_HEAL:
        '{{month}} is closed. Reopen the period, run the Revenue Tax correction again, then recalculate the assessment.',
    },
    mixedRegimeAmount: 'Cumulative {{tax}}: {{amount}} · collection code {{catalogCode}}.',
    mixedRegimeRecovery:
      'This revision was calculated before cumulative and non-cumulative revenue was separated by collection code. Select Refresh sources, review the new revision, and then approve it.',
    catalogCodeUnavailable: 'not provided',
    PIS_COFINS_DECLARATION_CORRECTION_REQUIRED: 'Period sources require a declaration correction.',
    PIS_COFINS_CASH_BASIS_REVENUE_OUTSIDE_AR:
      'Cash-basis revenue exists outside accounts receivable.',
    DECLARATION_CORRECTION_REQUIRED_OD7: 'A recoverable credit changed the original assessment.',
    LATE_REVENUE_DECLARATION_CORRECTION_I17:
      'Revenue identified after its legal month requires correction.',
  },
  sourceType: {
    REVENUE_PROVISION: 'Revenue provision',
    REVENUE_RELEASE: 'Revenue release',
    PURCHASE_CREDIT: 'Purchase credit',
    CUSTOMER_WITHHOLDING: 'Customer withholding',
    ADVANCE_ESTIMATE: 'Advance estimate',
    FISCAL_HISTORY: 'Tax history',
    JOURNAL_LINE: 'Journal line',
    MANUAL_EVIDENCE: 'Tax evidence',
    other: 'Tax source',
  },
  entitlementType: {
    PURCHASE_CREDIT: 'Purchase credit',
    CUSTOMER_WITHHOLDING: 'Customer withholding',
    SEGREGATED_RECOVERABLE: 'Segregated recoverable',
    LEGACY_CREDIT: 'Legacy credit',
    ADVANCE_ESTIMATE: 'Advance estimate',
    ISS_PAID_RECOVERABLE: 'Recoverable ISS',
    PAID_TAX_RECOVERABLE: 'Recoverable paid tax',
    other: 'Tax credit or withholding',
  },
  allocationReason: {
    PURCHASE_CREDIT_OFFSET: 'Purchase-credit offset',
    WITHHOLDING_OFFSET: 'Withholding offset',
    ADVANCE_ESTIMATE_OFFSET: 'Advance-estimate offset',
    NEGATIVE_ASSESSMENT_DELTA: 'Negative assessment adjustment',
    HEAD_OFFICE_TRANSFER: 'Head-office transfer',
    REVERSAL_CORRECTION: 'Reversal correction',
    CORRECTION: 'Correction',
    REVERSAL: 'Reversal',
    ALLOCATE: 'Allocation',
    RELEASE: 'Release',
    RECLASSIFY_SEGREGATED: 'Segregated reclassification',
    CONVERT_LEGACY: 'Legacy-credit conversion',
    other: 'Tax movement',
  },
  originStatus: { ACTIVE: 'Available', REVERSED: 'Reversed' },
  originSourceType: {
    HEAD_OFFICE_TRANSFER: 'Head-office transfer',
    AP_BILL_WITHHOLDING: 'Bill withholding',
    AP_VENDOR_PAYMENT: 'Vendor payment',
    AP_BILL_APPROVAL_LEGACY: 'Legacy bill approval',
    TAX_LIABILITY_RAIL_MIGRATION: 'Migrated tax balance',
    AR_DEBIT_NOTE: 'Debit note',
    CONTRACT_REVENUE_RECOGNITION: 'Contract revenue recognition',
    GL_JOURNAL: 'Journal entry',
    TAX_ASSESSMENT_TRUE_UP: 'Assessment adjustment',

    other: 'Tax origin',
  },
  postingKind: {
    EXPENSE_TRUE_UP: 'Expense true-up',
    SETTLEMENT_OFFSET: 'Balance-sheet offset',
    HEAD_OFFICE_TRANSFER: 'Head-office transfer',
    HEAD_OFFICE_RECOVERABLE_TRANSFER: 'Inter-entity tax credit transfer',
    FIXED_ASSET_CREDIT_MATURATION: 'Fixed-asset credit recognition',
    FIXED_ASSET_COMMON_USE_EXCLUSION: 'Fixed-asset common-use credit exclusion',
    GUIDE_REGISTRATION: 'Guide registration',
    REVERSAL: 'Reversal',
    CORRECTION: 'Correction',
    other: 'Assessment posting',
  },
  errors: {
    loadTitle: 'Could not load assessments',
    load: 'Try again.',
    action: 'Could not complete the action.',
    branchTransferAccountMissing:
      'Configure the “{{slot}}” mapping for entity “{{entity}}” before approving the head-office/branch transfer.',
    branchTransferAccountNotDedicated:
      'Account “{{account}}”, mapped as “{{slot}}” for entity “{{entity}}”, is not classified for consolidation elimination. Create a dedicated account with that classification and update the mapping before approval.',
    branchTransferSlots: {
      BRANCH_DUE_TO_HEAD_OFFICE: 'Due to head office',
      HEAD_OFFICE_DUE_FROM_BRANCH: 'Due from branch',
      BRANCH_DUE_FROM_HEAD_OFFICE: 'Tax-credit due from head office',
      HEAD_OFFICE_DUE_TO_BRANCH: 'Tax-credit due to branch',
    },
  },
};
